// @flow
import React from 'react';
import {FormattedNumber} from "react-intl";

import './Amount.less';

const Amount = ({balance, currency, color, context, noColor}) => {

    const valueClass = context === 'summary' ? 'amount__summary_value' : 'amount__value';
    const currencyClass = 'amount__currency';
    const colorStyle = color ? {color} : {};

    let classNameModifier = '';

    if (!noColor) {
        if(balance > 0) {
            classNameModifier = '--positive';
        } else if(balance < 0) {
            classNameModifier = '--negative';
        }
    }

    return <div className={'amount'}>
        <div className={`${valueClass} ${valueClass}${classNameModifier}`} style={colorStyle}>
            <FormattedNumber value={balance}/>
        </div>
        <span className={`${currencyClass} ${currencyClass}${classNameModifier}`} style={colorStyle}>{currency}</span>
    </div>
};

export default Amount;